/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=5b0e8ebe"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5b0e8ebe&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__